import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Logo from '../Logo'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import HeaderContactOptionsMenu from '../HeaderContactOptions/HeaderContactOptionsMenu'
import NavigationHeaderPhoneMenu from '../HeaderMain/NavigationHeader/NavigationHeaderPhoneMenu'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import IconButton from 'LuxKit/Button/IconButton'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CheckoutDevModeToggle from 'checkout/Components/Shared/CheckoutDevModeToggle'
import ExperimentPanelButton from './ExperimentPanelButton'

const HeaderContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${rem(4)} 0;
`

const BackButtonDesktop = styled(TextButton)`
  display: none;

  ${mediaQueryUp.largeDesktop} {
    display: inline-flex;
  }
`

const BackButtonMobile = styled(IconButton)`
  ${mediaQueryUp.largeDesktop} {
    display: none;
  }
`

const PhoneNumberMobile = styled(HeaderContactOptionsMenu)`
  ${mediaQueryUp.largeDesktop} {
    display: none;
  }
`

const HelpBodyText = styled(BodyText)`
  display: none;

  ${mediaQueryUp.largeDesktop} {
    display: block;
  }
`

const PhoneNumberDesktop = styled(NavigationHeaderPhoneMenu)`
  display: none;

  ${mediaQueryUp.largeDesktop} {
    display: flex;
  }
`

const PaddedLogo = styled(Logo)`
  padding: 0 ${rem(8)};
  align-items: center;
`

/** Mobile centres the page title where the logo otherwise sits; the logo returns from tablet up. */
const MobileTitleLogo = styled(PaddedLogo)`
  display: none;

  ${mediaQueryUp.tablet} {
    display: flex;
  }
`

const MobileTitle = styled(Heading)`
  padding: 0 ${rem(8)};
  text-align: center;

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const ArrowIcon = styled(LineArrowRightIcon)`
  transform: rotate(180deg);
`

const LeftContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`

const RightContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row-reverse;

  ${mediaQueryUp.largeDesktop} {
    flex-direction: row;
    justify-content: flex-end;
  }
`

interface Props {
  onBack: () => void
  /** Shown centred on mobile in place of the logo, for checkouts whose design titles the header. */
  mobileTitle?: string
}

function CommonHeaderCheckout(props: Props) {
  const intl = useIntl()
  const { onBack, mobileTitle } = props

  return <HeaderContainer>
    <LeftContent>
      <BackButtonDesktop kind="tertiary" variant="default" horizontalOutdent="start" size="large" startIcon={<ArrowIcon size="XS" />} onClick={onBack}>
        {intl.formatMessage({
          id: 'wagVffz19Oa6gpwa_-nH',
          defaultMessage: 'Back',
          description: 'Back button text in checkout header during the checkout and payment process',
        })}
      </BackButtonDesktop>
      <CheckoutDevModeToggle />
      <BackButtonMobile kind="tertiary" variant="default"size="large" onClick={onBack}>
        <ArrowIcon size="XS" />
      </BackButtonMobile>
    </LeftContent>
    {mobileTitle ? <>
      <MobileTitle as="h1" variant="heading6">{mobileTitle}</MobileTitle>
      <MobileTitleLogo mobileVariant="icon" />
    </> : <PaddedLogo mobileVariant="icon" />}
    <RightContent>
      <HelpBodyText colour="normal-contrast" variant="large" weight="bold">{intl.formatMessage({
        id: 'IRpTKdIFzWpUvqaHHI68',
        defaultMessage: 'Need help',
        description: 'Help text label in checkout header during the checkout and payment process',
      })}
      </HelpBodyText>
      <PhoneNumberDesktop />
      <PhoneNumberMobile size="large" />
      <ExperimentPanelButton />
    </RightContent>
  </HeaderContainer>
}

export default CommonHeaderCheckout
